import React from 'react';
import { MessageSquare, Download } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { ZodiacTheme } from './zodiacThemes';
interface OrdersTabProps {
  theme: ZodiacTheme;
  onNavigate: (page: string) => void;
  setActiveTab: (tab: string) => void;
}
export function OrdersTab({
  theme,
  onNavigate,
  setActiveTab
}: OrdersTabProps) {
  return <div className="space-y-6" data-id="element-15696">
      <div className="flex justify-between items-center mb-6" data-id="element-15697">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-15698">
          Заказы (Консультации)
        </h2>
        <Button onClick={() => onNavigate('astrologers')} data-id="element-15699">
          Найти астролога
        </Button>
      </div>

      <div className="space-y-4" data-id="element-15700">
        <Card padding="md" className="border-l-4 border-l-amber-500" data-id="element-15701">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-15702">
            <div className="flex items-start gap-4" data-id="element-15703">
              <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold flex-shrink-0" data-id="element-15704">
                ЕС
              </div>
              <div data-id="element-15705">
                <div className="flex items-center gap-3 mb-1" data-id="element-15706">
                  <span className="text-sm text-slate-500" data-id="element-15707">Заказ #1042</span>
                  <Badge variant="warning" data-id="element-15708">В работе</Badge>
                </div>
                <h3 className="font-bold text-slate-900" data-id="element-15709">
                  Консультация: Синастрия (Видео)
                </h3>
                <div className="text-sm text-slate-600 mt-1" data-id="element-15710">
                  Астролог: Елена Смирнова • 12 Окт 2024 • 5 000 ₽
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2" data-id="element-15711">
              <Button variant="outline" size="sm" icon={<MessageSquare className="w-4 h-4" data-id="element-15713" />} onClick={() => setActiveTab('chat')} data-id="element-15712">
                Открыть чат
              </Button>
            </div>
          </div>
        </Card>

        <Card padding="md" className="border-l-4 border-l-emerald-500 opacity-80" data-id="element-15714">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-15715">
            <div className="flex items-start gap-4" data-id="element-15716">
              <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 font-bold flex-shrink-0" data-id="element-15717">
                АК
              </div>
              <div data-id="element-15718">
                <div className="flex items-center gap-3 mb-1" data-id="element-15719">
                  <span className="text-sm text-slate-500" data-id="element-15720">Заказ #0984</span>
                  <Badge variant="success" data-id="element-15721">Завершён</Badge>
                </div>
                <h3 className="font-bold text-slate-900" data-id="element-15722">
                  Натальная карта (Текст)
                </h3>
                <div className="text-sm text-slate-600 mt-1" data-id="element-15723">
                  Астролог: Анна Коваль • 25 Сен 2024 • 3 500 ₽
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2" data-id="element-15724">
              <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-15726" />} data-id="element-15725">
                Скачать отчёт
              </Button>
              <Button variant="ghost" size="sm" data-id="element-15727">
                Оставить отзыв
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}